import { render, staticRenderFns } from "./MainImage.vue?vue&type=template&id=1daf42ad&scoped=true"
import script from "./MainImage.vue?vue&type=script&lang=js"
export * from "./MainImage.vue?vue&type=script&lang=js"
import style0 from "./MainImage.vue?vue&type=style&index=0&id=1daf42ad&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1daf42ad",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1daf42ad')) {
      api.createRecord('1daf42ad', component.options)
    } else {
      api.reload('1daf42ad', component.options)
    }
    module.hot.accept("./MainImage.vue?vue&type=template&id=1daf42ad&scoped=true", function () {
      api.rerender('1daf42ad', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/store/creatStore2/modules/MainImage.vue"
export default component.exports